import { FETCH_VLN_REGISTER_PROGRESS } from '../../constants/actionTypes'

export default (vlnRegisterProgress = {}, action) => {
    switch (action.type) {
        case FETCH_VLN_REGISTER_PROGRESS:
            return action.payload;
        default:
            return vlnRegisterProgress;
    }
}